<div class="row">
  <div class="col-lg-1 col-12">
    <app-uiform-side-menu [uiformId]="uiformId" [targetId]="target_name" [usecaseId]="usecaseId">
    </app-uiform-side-menu>
  </div>
  <div class="col-lg-11 col-12 my-margin-left" #content>
    <div class="row">
      <div class="col-md-12 mb-1">
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-1">
          <div class="breadcrumb-title border-0">
            <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div class="d-flex align-items-center">
                <mat-icon color="primary">pie_chart</mat-icon>
                <p class="ms-2 mb-0">
                  {{ form.data["title"] }}
                  {{ target_name == "chart-custom" ? "Dynamic" : "Quick" }}
                  Chart
                </p>
              </div>
            </div>
          </div>
          <div *ngIf="target_name != 'chart-custom'" class="compact-inputs dropdown-pd-none">
            <div class="d-flex gap-3 align-items-center flex-wrap">
              <!-- Field Select -->
              <div>
                <mat-form-field appearance="outline" class="w-100" style="min-width: 250px">
                  <mat-label>{{'Remains.FIELD'| translate}}</mat-label>
                  <mat-select [(ngModel)]="form.data['field']" name="SelectAttributes"
                    placeholder="{{'customReport.filter.placeholders.selectField' | translate}}" #SelectAttributes>
                    <mat-option value="undefined">{{'customReport.filter.placeholders.selectField' |
                      translate}}</mat-option>
                    <mat-option *ngFor="let e of filterAttributeLabel()" [value]="e['code']">
                      {{ e["label"] }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Buttons -->
              <div class="d-flex gap-2 flex-wrap">
                <!-- Draw Button -->
                <button mat-stroked-button color="primary" (click)="drawChart()" class="icon-center icon-width"
                  [disabled]="form.data['field'] === 'undefined'" matTooltip="{{'Remains.Draw'| translate}}"
                  matTooltipPosition="above">
                  <mat-icon>show_chart</mat-icon>
                  <span class="ms-2">{{'Remains.Draw'| translate}}</span>
                </button>

                <!-- Refresh Button -->
                <button mat-stroked-button color="primary" (click)="getUsecaseSchema(); resetSearchValues()"
                  class="icon-center icon-width" matTooltip="{{'Remains.Refresh'| translate}}"
                  matTooltipPosition="above">
                  <mat-icon>refresh</mat-icon>
                </button>

                <!-- PDF Button -->
                <button mat-stroked-button color="primary" (click)="downloadPDF()" matTooltip="PDF"
                  matTooltipPosition="above" class="icon-center icon-width">
                  <mat-icon>picture_as_pdf</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-dynamic-chart *ngIf="target_name == 'chart-custom'" [attributes]="usecaseAttributes" [data]="usecaseData"
        [collection_name]="usecase?.['collectionName']" />
      <div *ngIf="target_name != 'chart-custom'">
        <div *ngIf="loading">loading ...</div>
        <div class="row" *ngIf="!loading">
          <div *ngIf="usecaseData && usecaseData.length > 0">
            <div class="row mt-3">
              <ng-container *ngFor="let field of filterFieldsAttributes(); let i = index">
                <!-- Line or Bar Chart -->
                <div class="col-lg-6 col-md-12" [ngClass]="{ 'col-12': isLastOdd(i) }">
                  <div class="card shadow-sm chartcardheight">
                    <div class="card-header">
                      <h6 class="d-flex gap-2 align-items-center mb-0">
                        <span>{{ field.label }}</span>
                        <i *ngIf="field.type === 'date' || field.type === 'time'"
                          class="bi bi-bar-chart-line text-primary"></i>
                        <i *ngIf="field.type !== 'date' && field.type !== 'time'"
                          class="bi bi-bar-chart text-primary"></i>
                      </h6>
                    </div>
                    <div class="card-body">
                      <app-ncs-graph [attributes]="filterFieldsAttributes()" [data]="usecaseData"
                        [collectionName]="usecase?.['collectionName']" [field]="field" [chartType]="
                          field.type === 'date' || field.type === 'time'
                            ? 'line'
                            : 'bar'
                        " [isUserFilter]="isUserFilter">
                      </app-ncs-graph>
                    </div>
                  </div>
                </div>
                <!-- Pie Chart -->
                <div class="col-lg-6 col-md-12" *ngIf="
                    field.type !== 'date' &&
                    field.type !== 'time' &&
                    usecaseData.length < 10
                  " [ngClass]="{ 'col-12': isLastOdd(i + 1) }">
                  <div class="card shadow-sm chartcardheight">
                    <div class="card-header">
                      <h6 class="d-flex gap-2 align-items-center mb-0">
                        <span>{{ field.label }}</span>
                        <i class="bi bi-pie-chart-fill text-primary" title="Pie Chart"></i>
                      </h6>
                    </div>
                    <div class="card-body">
                      <app-ncs-graph [attributes]="filterFieldsAttributes()" [data]="usecaseData"
                        [collectionName]="usecase?.['collectionName']" [field]="field" [chartType]="'pie'"
                        [isUserFilter]="isUserFilter">
                      </app-ncs-graph>
                    </div>
                  </div>
                </div>
                <!-- Doughnut Chart -->
                <div class="col-lg-6 col-md-12" *ngIf="
                    field.type !== 'date' &&
                    field.type !== 'time' &&
                    usecaseData.length < 10
                  " [ngClass]="{ 'col-12': isLastOdd(i + 2) }">
                  <div class="card shadow-sm chartcardheight">
                    <div class="card-header">
                      <h6 class="d-flex gap-2 align-items-center mb-0">
                        <span>{{ field.label }}</span>
                        <i class="bi bi-opencollective text-primary" title="Doughnut Chart"></i>
                      </h6>
                    </div>
                    <div class="card-body">
                      <app-ncs-graph [attributes]="filterFieldsAttributes()" [data]="usecaseData"
                        [collectionName]="usecase?.['collectionName']" [field]="field" [chartType]="'doughnut'"
                        [isUserFilter]="isUserFilter">
                      </app-ncs-graph>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
